
import { useCallback } from 'react';
import useGnenrateColor from '../../CustomHooks/GenerateRandomColor';
import { getIntialsImageShow } from '../commonFunctions';

interface PaginationData {
  logo?: any,
  merchantCode?: string | any,
  merchantName?: string | any,
}

const RenderMerchantLogo = ({ logo, merchantCode, merchantName }: PaginationData) => {
  const [Randomcolor]: any = useGnenrateColor();
  const RenderImage = useCallback(() => {
    const  initials = getIntialsImageShow(merchantName) ; 
   
    const color = Randomcolor(initials);
    if (!logo) {
      return (
        <div className="circle" style={{ backgroundColor: color }}>
          <p className='logo-text'>  {initials}</p>
          {/* <img src={userlogo} alt="Logo" className="circle" /> */}
        </div>)
    }
    else {
      return (<img src={`data:image/jpeg;base64,${logo}`} alt="Logo" className="circle" />)
    }
  }, [logo, merchantCode, merchantName])



  return (
    RenderImage()
  )
}

export default RenderMerchantLogo; 